import React from 'react';

interface Props {
  active: boolean;
}

export const OverviewIcon: React.FC<Props> = ({
  active,
}: Props): JSX.Element => {
  return (
    <div className="submenu__body__link-icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {active ? (
          <path
            d="M4.33337 5.83335C4.33337 5.74131 4.40799 5.66669 4.50004 5.66669H11.5C11.5921 5.66669 11.6667 5.74131 11.6667 5.83335V7.00002H4.33337V5.83335ZM4.33337 8.00002V10.1667C4.33337 10.2587 4.40799 10.3334 4.50004 10.3334H6.00004V8.00002H4.33337ZM11.5 10.3334H7.00004V8.00002H11.6667V10.1667C11.6667 10.2587 11.5921 10.3334 11.5 10.3334ZM1.33337 4.50002C1.33337 3.4875 2.15419 2.66669 3.16671 2.66669H12.8334C13.8459 2.66669 14.6667 3.4875 14.6667 4.50002V11.5C14.6667 12.5125 13.8459 13.3334 12.8334 13.3334H3.16671C2.15419 13.3334 1.33337 12.5125 1.33337 11.5V4.50002ZM4.50004 4.66669C3.85571 4.66669 3.33337 5.18902 3.33337 5.83335V10.1667C3.33337 10.811 3.85571 11.3334 4.50004 11.3334H11.5C12.1444 11.3334 12.6667 10.811 12.6667 10.1667V5.83335C12.6667 5.18902 12.1444 4.66669 11.5 4.66669H4.50004Z"
            fill={active ? 'white' : '#646C83'}
            strokeWidth="1px"
            style={{ transition: 'all 0.2s linear' }}
          />
        ) : (
          <path
            d="M4.50004 4.66666C3.85571 4.66666 3.33337 5.18899 3.33337 5.83332V10.1667C3.33337 10.811 3.85571 11.3333 4.50004 11.3333H11.5C12.1444 11.3333 12.6667 10.811 12.6667 10.1667V5.83332C12.6667 5.18899 12.1444 4.66666 11.5 4.66666H4.50004ZM4.33337 5.83332C4.33337 5.74128 4.40799 5.66666 4.50004 5.66666H11.5C11.5921 5.66666 11.6667 5.74128 11.6667 5.83332V6.99999H4.33337V5.83332ZM7.00004 7.99999H11.6667V10.1667C11.6667 10.2587 11.5921 10.3333 11.5 10.3333H7.00004V7.99999ZM6.00004 7.99999V10.3333H4.50004C4.40799 10.3333 4.33337 10.2587 4.33337 10.1667V7.99999H6.00004ZM3.16671 2.66666C2.15419 2.66666 1.33337 3.48747 1.33337 4.49999V11.5C1.33337 12.5125 2.15419 13.3333 3.16671 13.3333H12.8334C13.8459 13.3333 14.6667 12.5125 14.6667 11.5V4.49999C14.6667 3.48747 13.8459 2.66666 12.8334 2.66666H3.16671ZM2.33337 4.49999C2.33337 4.03975 2.70647 3.66666 3.16671 3.66666H12.8334C13.2936 3.66666 13.6667 4.03975 13.6667 4.49999V11.5C13.6667 11.9602 13.2936 12.3333 12.8334 12.3333H3.16671C2.70647 12.3333 2.33337 11.9602 2.33337 11.5V4.49999Z"
            fill={active ? '#646c8391' : '#646C83'}
            style={{ transition: 'all 0.2s linear' }}
          />
        )}
      </svg>
    </div>
  );
};
